import * as Sentry from '@sentry/react';
const environment = import.meta.env.VITE_APP_ENV;

if (environment !== 'develop') {
  Sentry.init({
    dsn: 'https://764690006db523f9993809b1bd7fff9f@o4508766954979328.ingest.de.sentry.io/4508998336512080',
    integrations: [
      Sentry.replayIntegration({
        // NOTE: This will disable built-in masking. Only use this if your site has no sensitive data, or if you've already set up other options for masking or blocking relevant data, such as 'ignore', 'block', 'mask' and 'maskFn'.
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    environment: environment,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
